import {CompanyBase, CompanyType} from "./company";
import {UserBase} from "./user";
import {ProjectMetaId} from "@models/project";

/**
 *
 * */
enum PermissionTargetType {
    internal = 'internal',
    external = 'external',
}

export enum PermissionTypeEnum {
    None = 0,
    View = 2,
    Edit = 4,
    Admin = 8,
}

export interface DirectoryEntry {
    company: CompanyBase;
    user: UserBase;
}

export interface PermissionedDirectoryEntry extends DirectoryEntry {
    user_id: string;
    permission_target_type: PermissionTargetType;

    bidding: PermissionTypeEnum;
    directory: PermissionTypeEnum;
    project: PermissionTypeEnum;
    value_engineering: PermissionTypeEnum;
}

export interface PermissionedDirectoryEntryRef extends  PermissionedDirectoryEntry {
    project_meta: ProjectMetaId;
}


export interface CompanyPermissions {
    /**
     * */
    create_projects: boolean;
    edit_company_settings: boolean;
    edit_users: boolean;
    invite_users: boolean;
}


export type PermissionMeta = {
    /**
     * metadata for display purposes
     * */
    key: string,
    name: string,
    description: string,
    access?: CompanyType // avaliable to only this company type if exists.
}

export const CompanyPermissionDesriptions: PermissionMeta[] = [
    {
        key: "invite_users",
        name: "Invite Users",
        description: "",
    },
    {
        key: "create_projects",
        name: "Create Projects",
        description: "",
        access: CompanyType.developer
    },
    {
        key: "edit_company_settings",
        name: "Edit Company Settings",
        description: "",
    },
    {
        key: "edit_users",
        name: "Manage User profiles",
        description: "",
    },

]